import { EAssetAcquiredStatuses, EAssetAcquiredStatusesLabels } from '@enums/asset';

export const searchTooltipText = 'Search by Asset ID';

export const rentStatusOptions = [
	{
		label: EAssetAcquiredStatusesLabels.all,
		value: EAssetAcquiredStatuses.all,
	},
	{
		label: EAssetAcquiredStatusesLabels.current,
		value: EAssetAcquiredStatuses.current,
	},
	{
		label: EAssetAcquiredStatusesLabels.future,
		value: EAssetAcquiredStatuses.future,
	},
	{
		label: EAssetAcquiredStatusesLabels.past,
		value: EAssetAcquiredStatuses.past,
	},
];

export const datesOverlapTypeOptions = [
	{
		label: 'Fully included into',
		value: 'INSIDE',
	},
	{
		label: 'Overlaps start date',
		value: 'OVERLAP_START',
	},
	{
		label: 'Overlaps end date',
		value: 'OVERLAP_END',
	},
];

export const endDateTypeOptions = [
	{
		label: 'Requested',
		value: 'REQUESTED',
	},
	{
		label: 'Actual',
		value: 'ACTUAL',
	},
];

export const acquiredAssetProfilePath = 'asset-profile';
